<script>
  /**
   * 押したことが明確な Submit ボタン
   */
  export let isSubmitting = false
</script>

<div class="field">
  <div class="control">
    <button
      type="submit"
      class="button is-link"
      data-testid="submitButton"
      class:is-loading={isSubmitting}
      disabled={isSubmitting}
    >
      <slot>Submit</slot>
    </button>
  </div>
</div>
